"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../reducers");
const SettingsExperiencePreview = ({ editableCampaign, experiences, isWizardModalOpen, }) => {
    const { experienceId, notificationTapBehaviorType } = editableCampaign;
    if (!isWizardModalOpen && notificationTapBehaviorType === 'OPEN_EXPERIENCE') {
        const experience = experiences.filter(({ id }) => id === experienceId)[0];
        const simulatorURL = experience ? `${experience.simulatorURL}?showStatusBar=true` : undefined;
        return (React.createElement(React.Fragment, null, ReactDOM.createPortal(React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    position: 'absolute',
                    top: 96,
                    left: 24,
                    textAlign: 'center',
                    width: 320,
                    height: 568,
                    background: 'white linear-gradient(rgba(233,233,233,1.0), rgba(238,238,238,0.5))',
                    zIndex: 10,
                } }),
            React.createElement("iframe", { id: "experience-preview-settings-page", src: simulatorURL, style: {
                    position: 'absolute',
                    top: 96,
                    zIndex: 11,
                    left: 24,
                    height: 568,
                    width: 320,
                } })), document.getElementById('phone-bezel'))));
    }
    return null;
};
const mapStateToProps = (state) => ({
    editableCampaign: reducers_1.getEditableCampaign(state),
    currentWizard: reducers_1.getCurrentWizard(state),
    experiences: reducers_1.getExperiences(state),
    isWizardModalOpen: reducers_1.getIsWizardModalOpen(state),
});
exports.default = react_redux_1.connect(mapStateToProps, {})(SettingsExperiencePreview);
